<template>
  <div class="min-h-screen bg-gray-50">
    <!-- Header -->
    <header class="bg-white shadow-sm">
      <div class="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-4">
        <div class="flex justify-between items-center">
          <div>
            <h1 class="text-2xl font-bold text-gray-900"> <img src="../assets/logo@2x.png" class="w-[90px] sm:w-[150px]" alt="Logo"></h1>
            <p class="text-gray-500 hidden sm:block">Menaxho në mënyrë efektive</p>
          </div>
          <div class="flex items-center space-x-4">
            <div class="relative">
              <input 
                v-model="searchQuery" 
                type="text" 
                placeholder="Kërko leads..." 
                class="pl-10 pr-4 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-indigo-500 focus:border-indigo-500"
              >
              <i class="fas fa-search absolute left-3 top-3 text-gray-400"></i>
            </div>
            <button @click="$router.push('/settings')" class="p-2 rounded-full hover:bg-gray-100 focus:outline-none">
              <i class="fas fa-cog text-gray-500 text-xl"></i>
            </button>
            
          </div>
        </div>
      </div>
    </header>

    <!-- Stats Cards -->
     
    <div class="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-6">
      <div class="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6 mb-8">
        <div class="bg-white rounded-xl shadow-sm p-6 border-l-4 border-indigo-500">
          <div class="flex items-center">
            <div class="rounded-full bg-indigo-100 p-3 mr-4">
              <i class="fas fa-users text-indigo-600"></i>
            </div>
            <div>
              <p class="text-sm font-medium text-gray-500">Total Leads</p>
              <p class="text-2xl font-semibold text-gray-900">{{ filteredLeads.length }}</p>
            </div>
          </div>
        </div>
        <div class="bg-white rounded-xl shadow-sm p-6 border-l-4 border-purple-500">
          <div class="flex items-center">
            <div class="rounded-full bg-purple-100 p-3 mr-4">
              <i class="fas fa-handshake text-purple-600"></i>
            </div>
            <div>
              <p class="text-sm font-medium text-gray-500">Takime të planifikuara</p>
              <p class="text-2xl font-semibold text-gray-900">{{ stats.meetingsScheduled }}</p>
            </div>
          </div>
        </div>
        <div class="bg-white rounded-xl shadow-sm p-6 border-l-4 border-blue-500">
          <div class="flex items-center">
            <div class="rounded-full bg-blue-100 p-3 mr-4">
              <i class="fas fa-comments text-blue-600"></i>
            </div>
            <div>
              <p class="text-sm font-medium text-gray-500">Kontaktuar këtë javë</p>
              <p class="text-2xl font-semibold text-gray-900">{{ stats.contactedThisWeek }}</p>
            </div>
          </div>
        </div>
        <div class="bg-white rounded-xl shadow-sm p-6 border-l-4 border-green-500">
          <div class="flex items-center">
            <div class="rounded-full bg-green-100 p-3 mr-4">
              <i class="fas fa-chart-line text-green-600"></i>
            </div>
            <div>
              <p class="text-sm font-medium text-gray-500">Shkalla e konvertimit me fitim</p>
              <p class="text-2xl font-semibold text-gray-900">{{ stats.closedWonCount }} ({{ stats.conversionRate }}%)</p>
            </div>
          </div>
        </div>
      </div>
 
      <div class="flex items-center justify-between mb-6">
        <button @click="$router.push('/analytics')" class="bg-gray-100 hover:bg-gray-200 text-indigo-700 px-4 py-2 rounded-lg flex items-center border border-indigo-200 shadow-sm transition-all duration-150">
          <i class="fas fa-chart-bar mr-2"></i>
          Shiko Analitikën
        </button>
        <button @click="showAddLeadModal = true" class="bg-indigo-600 hover:bg-indigo-700 text-white px-4 py-2 rounded-lg flex items-center">
          <i class="fas fa-plus mr-2"></i>
          Shto Lead
        </button>
      </div>
      <br>
      <!-- Filters -->
      <div class="bg-white rounded-xl shadow-sm p-6 mb-6">
        <div class="flex flex-wrap gap-4">
          <div>
            <label class="block text-sm font-medium text-gray-700 mb-1">Kanal</label>
            <select v-model="filters.channel" class="rounded-lg border-gray-300 focus:border-indigo-500 focus:ring-indigo-500">
              <option value="">Të gjitha kanalet</option>
              <option v-for="channel in channels" :key="channel" :value="channel">{{ channel }}</option>
            </select>
          </div>
          <div>
            <label class="block text-sm font-medium text-gray-700 mb-1">Statuset</label>
            <select v-model="filters.status" class="rounded-lg border-gray-300 focus:border-indigo-500 focus:ring-indigo-500">
              <option value="">Të gjitha statuset</option>
              <option v-for="status in statuses" :key="status" :value="status">{{ status }}</option>
            </select>
          </div>
          <div>
            <label class="block text-sm font-medium text-gray-700 mb-1">Kategori</label>
            <select v-model="filters.category" class="rounded-lg border-gray-300 focus:border-indigo-500 focus:ring-indigo-500">
              <option value="">Të gjitha kategoritë</option>
              <option v-for="category in categories" :key="category" :value="category">{{ category }}</option>
            </select>
          </div>
            <div>
          <label class="block text-sm font-medium text-gray-700 mb-1">Muaj</label>
          <select v-model="filters.month" class="rounded-lg border-gray-300 focus:border-indigo-500 focus:ring-indigo-500">
            <option value="">Të gjitha muajt</option>
            <option value="0">Janar</option>
            <option value="1">Shkurt</option>
            <option value="2">Mars</option>
            <option value="3">Prill</option>
            <option value="4">Maj</option>
            <option value="5">Qershor</option>
            <option value="6">Korrik</option>
            <option value="7">Gusht</option>
            <option value="8">Shtator</option>
            <option value="9">Tetor</option>
            <option value="10">Nëntor</option>
            <option value="11">Dhjetor</option>
          </select>
        </div>

          <div class="flex items-end">
            <button @click="clearFilters" class="text-gray-500 hover:text-gray-700 flex items-center">
              <i class="fas fa-times mr-1"></i> Pastro Filterat
            </button>
          </div>
        </div>
      </div>

      <!-- Leads Table -->
      <div class="bg-white rounded-xl shadow-sm overflow-hidden">
        <div class="overflow-x-auto ">
          <table class="min-w-full divide-y divide-gray-200 ">
            <thead class="bg-gray-50">
              <tr>
                <th scope="col" class="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">Data</th>
                <th scope="col" class="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">Emri dhe Mbiemri</th>
                <th scope="col" class="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">Kanal</th>
                <th scope="col" class="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">Kontakt</th>
                <th scope="col" class="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">Kategori</th>
                <th scope="col" class="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">Status</th>
                <th scope="col" class="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">Takimi i fundit</th>
              </tr>
            </thead>
            <tbody class="bg-white divide-y divide-gray-200">
              <tr v-for="lead in filteredLeads" :key="lead.id" class="hover:bg-gray-50" @click="viewLead(lead)">
                <td class="px-6 py-4 whitespace-nowrap text-sm text-gray-500">{{ formatDate(lead.date) }}</td>
                <td class="px-6 py-4 whitespace-nowrap">
                  <div class="text-sm font-medium text-gray-900">{{ lead.name }}</div>
                </td>
                <td class="px-6 py-4 whitespace-nowrap">
                  <span :class="`inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-medium ${getChannelClass(lead.channel)}`">
                    <i :class="getChannelIcon(lead.channel)" class="mr-1"></i>
                    {{ lead.channel }}
                  </span>
                </td>
                <td class="px-6 py-4 whitespace-nowrap text-sm text-gray-500">{{ lead.contact }}</td>
                <td class="px-6 py-4 whitespace-nowrap text-sm text-gray-500">{{ lead.category }}</td>
                <td class="px-6 py-4 whitespace-nowrap">
                  <span :class="`inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-medium ${getStatusClass(lead.status)}`">
                    {{ lead.status }}
                  </span>
                </td>
                <td class="px-6 py-4 whitespace-nowrap text-sm text-gray-500">
                  <spna class="px-2 py-1 bg-gray-100 rounded whitespace-nowrap">{{ lead.meetings[lead.meetings.length - 1] }} </spna>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
        
        <!-- Empty State -->
        <div v-if="filteredLeads.length === 0" class="text-center py-12">
          <i class="fas fa-inbox text-gray-300 text-5xl mb-4"></i>
          <h3 class="text-lg font-medium text-gray-900">Nuk u gjetën leads</h3>
          <p class="text-gray-500 mt-1">Filloni duke shtypur butonin “Shto Lead”</p>
          <button @click="showAddLeadModal = true" class="mt-4 inline-flex items-center px-4 py-2 border border-transparent shadow-sm text-sm font-medium rounded-md text-white bg-indigo-600 hover:bg-indigo-700">
            <i class="fas fa-plus mr-2"></i>
            Shto Lead
          </button>
        </div>
      </div>
    </div>

    <!-- Add/Edit Lead Modal -->
    <div v-if="showAddLeadModal || showEditLeadModal" class="fixed inset-0 overflow-y-auto z-50">
  <div class="flex items-center justify-center min-h-screen pt-4 px-4 pb-20 text-center sm:block sm:p-0">
    <div class="fixed inset-0 bg-gray-500 bg-opacity-75 transition-opacity" @click="closeModal"></div>
    
    <div class="inline-block align-bottom bg-white rounded-lg text-left overflow-hidden shadow-xl transform transition-all sm:my-8 sm:align-middle sm:max-w-lg sm:w-full">
      <div class="bg-white px-4 pt-5 pb-4 sm:p-6 sm:pb-4">
        <h3 class="text-lg leading-6 font-medium text-gray-900 mb-4">
          {{ showEditLeadModal ? 'Redakto Lead' : 'Shto Lead të Ri' }}
        </h3>
        <form @submit.prevent="submitForm">
          <div class="grid grid-cols-1 gap-4">
            <div>
              <label class="block text-sm font-medium text-gray-700">Emër</label>
              <input v-model="formData.name" type="text" required class="mt-1 block w-full rounded-md border-2 border-gray-400 shadow-md px-3 py-2 focus:border-indigo-500 focus:ring focus:ring-indigo-300">
            </div>
            
            <div>
              <label class="block text-sm font-medium text-gray-700">Kanal</label>
              <select v-model="formData.channel" required class="mt-1 block w-full rounded-md border-2 border-gray-400 shadow-md px-3 py-2 focus:border-indigo-500 focus:ring focus:ring-indigo-300">
                <option value="" disabled>Zgjidh një kanal</option>
                <option v-for="channel in channels" :key="channel" :value="channel">{{ channel }}</option>
              </select>
            </div>
            
            <div>
              <label class="block text-sm font-medium text-gray-700">Kontakt</label>
              <input v-model="formData.contact" type="text" required class="mt-1 block w-full rounded-md border-2 border-gray-400 shadow-md px-3 py-2 focus:border-indigo-500 focus:ring focus:ring-indigo-300">
            </div>
            
            <div>
              <label class="block text-sm font-medium text-gray-700">Kategori</label>
              <select v-model="formData.category" required class="mt-1 block w-full rounded-md border-2 border-gray-400 shadow-md px-3 py-2 focus:border-indigo-500 focus:ring focus:ring-indigo-300">
                <option value="" disabled>Zgjidh një kategori</option>
                <option v-for="category in categories" :key="category" :value="category">{{ category }}</option>
              </select>
            </div>
            
            
            <div>
              <label class="block text-sm font-medium text-gray-700">Status</label>
              <select v-model="formData.status" required class="mt-1 block w-full rounded-md border-2 border-gray-400 shadow-md px-3 py-2 focus:border-indigo-500 focus:ring focus:ring-indigo-300">
                <option value="" disabled>Zgjidh një status</option>
                <option v-for="status in statuses" :key="status" :value="status">{{ status }}</option>
              </select>
            </div>
            
            <div v-for="(meeting, index) in formData.meetings" :key="index">
              <label class="block text-sm font-medium text-gray-700">Shënimet e Takimit {{ index + 1 }}</label>
              <textarea v-model="formData.meetings[index]" rows="3" class="mt-1 block w-full rounded-md border-2 border-gray-400 shadow-md px-3 py-2 focus:border-indigo-500 focus:ring focus:ring-indigo-300"></textarea>
            </div>
            <button type="button" @click="formData.meetings.push('')" class="mt-2 inline-flex items-center px-3 py-2 border border-transparent text-sm leading-4 font-medium rounded-md text-white bg-green-600 hover:bg-green-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-green-500">
              <i class="fas fa-plus mr-2"></i> Shto Shënime Takimi
            </button>
          </div>
        </form>
      </div>
      <div class="bg-gray-50 px-4 py-3 sm:px-6 sm:flex sm:flex-row-reverse">
        <button type="button" @click="submitForm" class="w-full inline-flex justify-center rounded-md border border-transparent shadow-sm px-4 py-2 bg-indigo-600 text-base font-medium text-white hover:bg-indigo-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500 sm:ml-3 sm:w-auto sm:text-sm">
          {{ showEditLeadModal ? 'Përditëso' : 'Krijo' }}
        </button>
        <button type="button" @click="closeModal" class="mt-3 w-full inline-flex justify-center rounded-md border border-gray-300 shadow-sm px-4 py-2 bg-white text-base font-medium text-gray-700 hover:bg-gray-50 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500 sm:mt-0 sm:ml-3 sm:w-auto sm:text-sm">
          Anulo
        </button>
      </div>
    </div>
  </div>
</div>


    <!-- View Lead Modal -->
    <div v-if="showViewLeadModal" class="fixed inset-0 overflow-y-auto z-50">
      <div class="flex items-center justify-center min-h-screen pt-4 px-4 pb-20 text-center sm:block sm:p-0">
        <div class="fixed inset-0 bg-gray-500 bg-opacity-75 transition-opacity" @click="closeModal"></div>
        
        <div class="inline-block align-bottom bg-white rounded-lg text-left overflow-hidden shadow-xl transform transition-all sm:my-8 sm:align-middle sm:max-w-2xl sm:w-full">
          <div class="bg-white px-4 pt-5 pb-4 sm:p-6 sm:pb-4">
            <div class="sm:flex sm:items-start">
              <div class="mx-auto flex-shrink-0 flex items-center justify-center h-12 w-12 rounded-full bg-indigo-100 sm:mx-0 sm:h-10 sm:w-10">
                <i class="fas fa-user text-indigo-600"></i>
              </div>
              <div class="mt-3 text-center sm:mt-0 sm:ml-4 sm:text-left w-full">
                <h3 class="text-lg leading-6 font-medium text-gray-900">
                  Lead Detajet
                </h3>
                <div class="mt-4 grid grid-cols-1 md:grid-cols-2 gap-4">
                  <div>
                    <p class="text-sm text-gray-500">Emër</p>
                    <p class="text-sm font-medium text-gray-900">{{ selectedLead.name }}</p>
                  </div>
                  <div>
                    <p class="text-sm text-gray-500">Data e shtuar</p>
                    <p class="text-sm font-medium text-gray-900">{{ formatDate(selectedLead.date) }}</p>
                  </div>
                  <div>
                    <p class="text-sm text-gray-500">Kanal</p>
                    <p class="text-sm font-medium text-gray-900">{{ selectedLead.channel }}</p>
                  </div>
                  <div>
                    <p class="text-sm text-gray-500">Kontakt</p>
                    <p class="text-sm font-medium text-gray-900">{{ selectedLead.contact }}</p>
                  </div>
                  <div>
                    <p class="text-sm text-gray-500">Kategori</p>
                    <p class="text-sm font-medium text-gray-900">{{ selectedLead.category }}</p>
                  </div>
                  <div>
                    <p class="text-sm text-gray-500">Status</p>
                    <span :class="`inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-medium ${getStatusClass(selectedLead.status)}`">
                      {{ selectedLead.status }}
                    </span>
                  </div>
                  <div v-for="(meeting, index) in selectedLead.meetings" :key="index" class="md:col-span-2">
                    <p class="text-sm text-gray-500">Shënimet e Takimit {{ index + 1 }}</p>
                    <p class="text-sm font-medium text-gray-900">{{ meeting || 'Nuk ka shënime të disponueshme' }}</p>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <!-- <i class="fas fa-trash"></i> -->
          <div class="bg-gray-50 px-4 py-3 sm:px-6 sm:flex sm:flex-row-reverse">
            <button type="button" @click="deleteLead(selectedLead.id)" class="w-full inline-flex justify-center rounded-md border border-transparent shadow-sm px-4 py-2 bg-red-600 text-base font-medium text-white hover:bg-red-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-red-500 sm:ml-3 sm:w-auto sm:text-sm">
              Fshi
            </button>
            <button type="button" @click="editLead(selectedLead)" class="w-full inline-flex justify-center rounded-md border border-transparent shadow-sm px-4 py-2 bg-indigo-600 text-base font-medium text-white hover:bg-indigo-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500 sm:ml-3 sm:w-auto sm:text-sm">
              Redakto
            </button>
            <button type="button" @click="closeModal" class="mt-3 w-full inline-flex justify-center rounded-md border border-gray-300 shadow-sm px-4 py-2 bg-white text-base font-medium text-gray-700 hover:bg-gray-50 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500 sm:mt-0 sm:ml-3 sm:w-auto sm:text-sm">
              Anulo
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
  <Footer />
</template>

<script>
import { db, collection, getDocs, addDoc, doc, updateDoc, deleteDoc, onSnapshot,getDoc } from '../firebase.js'
import { getAuth, onAuthStateChanged } from 'firebase/auth'
import Swal from 'sweetalert2'
import { logLeadActivity } from '../script/tracker.js'
import Footer from '../componenets/Footer.vue' 

export default {
  name: 'LeadManagementDashboard',
  components: {
    Footer  
  },
  data() {
    return {
      searchQuery: '',
      filters: {
        channel: '',
        status: '',
        category: '',
        month: '',
      },
      showAddLeadModal: false,
      showEditLeadModal: false,
      showViewLeadModal: false,
      formData: {
        id: null,
        name: '',
        channel: '',
        contact: '',
        category: '',
        status: '',
        meetings: []
      },
      selectedLead: {},
      leads: [],
      channels: ['WhatsApp', 'Viber',"Facebook", 'Instagram', 'TikTok', 'Telefonat',"Web", 'In-person'],
      statuses: ['I Ri', 'Takuar', 'Takim i Planifikuar', 'Propozimi Dërguar', 'Negociata', 'Mbyllur Fitim', 'Mbyllur Humbje'],
      categories: ['Shitje', 'Blerje', 'Interesim', "Banes me qera", 'Ndermjetsim', 'Reklam',]
    }
  },

  async created() {
    const userStr = localStorage.getItem('user');
    if (!userStr) return;
    const user = JSON.parse(userStr);
    const auth = getAuth();
    onAuthStateChanged(auth, (firebaseUser) => {
      if (!firebaseUser || firebaseUser.uid !== user.uid) {
     
        return;
      }
      // User is valid, fetch leads
      const leadsRef = collection(db, 'leads')
      onSnapshot(leadsRef, (snapshot) => {
        this.leads = snapshot.docs
          .map(doc => ({
            id: doc.id,
            ...doc.data(),
            date: doc.data().date ? new Date(doc.data().date.seconds * 1000) : new Date()
          }))
          .filter(lead => !lead.deleted);
      })
    });
  },

  computed: {
filteredLeads() {
  const filtered = this.leads.filter(lead => {
    const matchesSearch =
      lead.name?.toLowerCase().includes(this.searchQuery.toLowerCase()) ||
      lead.contact?.toLowerCase().includes(this.searchQuery.toLowerCase()) ||
      lead.category?.toLowerCase().includes(this.searchQuery.toLowerCase());

    const matchesChannel = !this.filters.channel || lead.channel === this.filters.channel;
    const matchesStatus = !this.filters.status || lead.status === this.filters.status;
    const matchesCategory = !this.filters.category || lead.category === this.filters.category;

    const leadDate = new Date(lead.date);
    const matchesMonth = this.filters.month === '' || leadDate.getMonth() === parseInt(this.filters.month);

    return matchesSearch && matchesChannel && matchesStatus && matchesCategory && matchesMonth;
  });


  return filtered.sort((a, b) => new Date(b.date) - new Date(a.date));
},

    stats() {
      const contactedThisWeek = this.filteredLeads.filter(lead => {
        const oneWeekAgo = new Date();
        oneWeekAgo.setDate(oneWeekAgo.getDate() - 7);
        return lead.date >= oneWeekAgo && lead.status === 'Takuar';
      }).length;
      
      const meetingsScheduled = this.filteredLeads.filter(lead => 
        lead.status === 'Takim i Planifikuar'
      ).length;
      
      const closedWon = this.filteredLeads.filter(lead => 
        lead.status === 'Mbyllur Fitim'
      ).length;
      
      const conversionRate = this.filteredLeads.length > 0 
        ? Math.round((closedWon / this.filteredLeads.length) * 100) 
        : 0;
      
      const closedWonCount = this.filteredLeads.filter(lead => lead.status === 'Mbyllur Fitim').length;

      return {
        contactedThisWeek,
        meetingsScheduled,
        conversionRate,
        closedWonCount
      };
    }
  },

  methods: {
    formatDate(date) {
      return new Date(date).toLocaleDateString('en-US', {
        year: 'numeric',
        month: 'short',
        day: 'numeric'
      });
    },
    getChannelClass(channel) {
  const classes = {
    'WhatsApp': 'bg-green-100 text-green-800',
    'Viber': 'bg-purple-100 text-purple-800',
    'Instagram': 'bg-pink-100 text-pink-800',
    'In-person': 'bg-blue-100 text-blue-800',
    'TikTok': 'bg-pink-600 text-white',
    'Facebook': 'bg-blue-200 text-blue-900',
    'Telefonat': 'bg-yellow-100 text-yellow-800',
    'Web': 'bg-cyan-100 text-cyan-800' 
  };
  return classes[channel] || 'bg-gray-100 text-gray-800';
},

getChannelIcon(channel) {
  const icons = {
    'WhatsApp': 'fab fa-whatsapp',
    'Viber': 'fab fa-viber',
    'In-person': 'fas fa-handshake',
    'Instagram': 'fab fa-instagram',
    'TikTok': 'fab fa-tiktok',
    'Facebook': 'fab fa-facebook-f',
    'Telefonat': 'fas fa-phone',
    'Web': 'fas fa-globe' 
  };
  return icons[channel] || 'fas fa-question';
},



    getStatusClass(status) {
      const classes = {
        'I Ri': 'bg-blue-100 text-blue-800',
        'Takuar': 'bg-yellow-100 text-yellow-800',
        'Takim i Planifikuar': 'bg-indigo-100 text-indigo-800',
        'Propozimi Dërguar': 'bg-purple-100 text-purple-800',
        'Negociata': 'bg-orange-100 text-orange-800',
        'Mbyllur Fitim': 'bg-green-100 text-green-800',
        'Mbyllur Humbje': 'bg-red-100 text-red-800'
      };
      return classes[status] || 'bg-gray-100 text-gray-800';
    },

    viewLead(lead) {
      this.selectedLead = { ...lead };
      this.showViewLeadModal = true;
    },

    editLead(lead) {
      this.formData = { ...lead };
      if (!this.formData.meetings) this.formData.meetings = [];
      this.showEditLeadModal = true;
      this.showViewLeadModal = false;
    },

    async deleteLead(id) {
  if (!confirm('Are you sure you want to delete this lead?')) return;

  try {
    const leadRef = doc(db, 'leads', id);
    const leadSnap = await getDoc(leadRef);

    if (!leadSnap.exists()) {
      console.error('Lead not found');
      return;
    }

    const leadData = leadSnap.data();

    // Označi lead kao izbrisan
    await updateDoc(leadRef, { deleted: true });

    // Loguj delete akciju u Firestore
    await logLeadActivity('delete', { id, ...leadData });

  } catch (error) {
    console.error('Error deleting lead:', error);
  }
},

    async submitForm() {
  const leadData = {
    name: this.formData.name,
    channel: this.formData.channel,
    contact: this.formData.contact,
    category: this.formData.category,
    status: this.formData.status,
    meetings: this.formData.meetings,
    date: this.showEditLeadModal ? this.formData.date : new Date()
  }

  if (this.showEditLeadModal && this.formData.id) {

    const leadRef = doc(db, 'leads', this.formData.id)
    const oldDocSnap = await getDoc(leadRef)
    const oldLead = oldDocSnap.exists() ? oldDocSnap.data() : {}


    await updateDoc(leadRef, leadData)

    // Izračunaj promene
    const changes = {}
    for (const key in leadData) {
      if (JSON.stringify(leadData[key]) !== JSON.stringify(oldLead[key])) {
        changes[key] = { old: oldLead[key], new: leadData[key] }
      }
    }


    if (Object.keys(changes).length > 0) {
      await logLeadActivity('edit', { id: this.formData.id, ...leadData }, changes)
    }

  } else {

    const docRef = await addDoc(collection(db, 'leads'), leadData)
    const newLead = { id: docRef.id, ...leadData }

    
    await logLeadActivity('add', newLead)
  }

  this.closeModal()
  Swal.fire({
  title: 'Sukses',
  text: 'U përditësua me sukses',
  icon: "success"
})

},

    closeModal() {
      this.showAddLeadModal = false;
      this.showEditLeadModal = false;
      this.showViewLeadModal = false;
      this.formData = {
        id: null,
        name: '',
        channel: '',
        contact: '',
        category: '',
        status: '',
        meetings: []
      };
    },

    clearFilters() {
      this.filters = { channel: '', status: '', category: '',month: '' }
      this.searchQuery = ''
    }
  }
}
</script>

<style scoped>
.scroll-top {
  width: 100%;overflow-x: scroll;
}

</style>